module.exports = __webpack_public_path__ + "img/logo.209e6a2c.png";